import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Button from "../../../../../components/button/Button";
import { BUTTON_TYPE } from "../../../../../components/button/constants";
import CheckboxWLabel from "../../../../../components/checkbox/checkboxwlabel/CheckboxWLabel";
import TextArea from "../../../../../components/input/textarea/TextArea";
import Loadable from "../../../../../components/loadable/Loadable";
import { TOASTER_VARIANT } from "../../../../../components/toast/constants";
import { addNotifications } from "../../../../toaster/ToasterPortalSlice";
import { submitFileOrPastedData } from "../../BatchImportSaga";
import { setIsQuarterSelectionPopupOpen, setQuarterSelectionPopupTriggeredByModule, updateBatchImportFormData } from "../../BatchImportSlice";
import QuarterSelectionPopup from "../../components/quarterselectionpopup/QuarterSelectionPopup";
import { BATCH_FORMS_LOADING_STATES, BATCH_FORM_STATES_MESSAGE_MAP, QUARTER_SELECTION_FROM } from "../../constants";
import styles from './UploadFile.styles';

export default function PasteView({loadingState, batchImportFormData, setRefreshStep = () => {}, formSettings, isQuarterSelectionPopupOpen, quarterSelectionPopupTriggeredByModule}) {

    const [isQuarterValueForMatchingFieldsStepSetForFileView, setIsQuarterValueForMatchingFieldsStepSetForFileView] = useState(null);
    const dispatch = useDispatch();

    useEffect(() => {
		if(isQuarterValueForMatchingFieldsStepSetForFileView){
			dispatchFileOrPastedData(batchImportFormData, "Text");
            setIsQuarterValueForMatchingFieldsStepSetForFileView(null)
		}
	}, [isQuarterValueForMatchingFieldsStepSetForFileView]);

    const dispatchFileOrPastedData = (batchImportFormData, mode) => {
        dispatch(submitFileOrPastedData({
            formId: batchImportFormData?.selectedForm?.FormId ?? null, 
            data: {
                Mode : mode,
                IsCorrected : batchImportFormData.filingForCorrected,
                Data : batchImportFormData.pastedFileData,
                TaxYear : batchImportFormData.selectedYear
            },
            year: batchImportFormData?.selectedYear ?? null,
            actionLoadingState: {
                loading: BATCH_FORMS_LOADING_STATES.PASTE_FILE_PAGE_LOADING,
                ready: BATCH_FORMS_LOADING_STATES.PASTE_FILE_PAGE_READY,
            }
        }));
    }

    const handleNextBtnClick = (batchImportFormData, mode) => {        
        if(batchImportFormData?.pastedFileData.trim() !== ""){
            if(formSettings?.quarterOptions && (formSettings?.quarterOptions).length > 0){
                dispatch(setIsQuarterSelectionPopupOpen(true));
                dispatch(setQuarterSelectionPopupTriggeredByModule(QUARTER_SELECTION_FROM.GOTONEXTSTEPFROMFILEUPLOADSTEP));
            }else{
                dispatchFileOrPastedData(batchImportFormData, mode);
            }
            
        }else{
            dispatch(addNotifications({ heading: "No data pasted", message: "Copy & Paste the Excel data to continue.", variant: TOASTER_VARIANT.WARNING }));
        }
    }

    const handleQuarterSelectionConfirmationClick = (quarterValue) => {
		if(quarterSelectionPopupTriggeredByModule === QUARTER_SELECTION_FROM.GOTONEXTSTEPFROMFILEUPLOADSTEP){
			dispatch(updateBatchImportFormData({
				quarter: quarterValue,
			}));
            setIsQuarterValueForMatchingFieldsStepSetForFileView(true)
			dispatch(setQuarterSelectionPopupTriggeredByModule(null));
		}
		dispatch(setIsQuarterSelectionPopupOpen(false));
	}

    return <>
        <Loadable
            currentState={loadingState.state} 
            loadingStates={[BATCH_FORMS_LOADING_STATES.STEP1_PAGE_LOADING, BATCH_FORMS_LOADING_STATES.PASTE_FILE_PAGE_LOADING]} 
            messageMap={BATCH_FORM_STATES_MESSAGE_MAP}
            isNewLoadable={true}
        >
            <div style={styles.uploadScreenContainer}>
                <TextArea customStyles={styles.textAreaCustomStyles} value={batchImportFormData.pastedFileData} onChangeCb={(e) => dispatch(updateBatchImportFormData({pastedFileData: e.target.value}))} rows={10} />
                {
                    formSettings?.showCorrectedReturnCheckBox && <div style={styles.correctedCheckboxDiv}>
                        <CheckboxWLabel label="Check if filing for corrected" checked={batchImportFormData?.filingForCorrected} onChangeCb={() => {dispatch(updateBatchImportFormData({filingForCorrected : !batchImportFormData?.filingForCorrected})) }} />
                    </div>
                }
                <div style={styles.mainButtonsContainer}>
                    <Button type={BUTTON_TYPE.PRIMARY} onClickCb={() => handleNextBtnClick(batchImportFormData, "Text")}>
                        Submit & Next
                    </Button>
                </div>
            </div>
            {
                isQuarterSelectionPopupOpen && <QuarterSelectionPopup 
                    isOpen={isQuarterSelectionPopupOpen}
                    confirmationButtonProps = {{
                        onConfirmationCb: (quarterValue) => {
                            handleQuarterSelectionConfirmationClick(quarterValue);
                        },
                        confirmationButtonText: "Ok",
                        confirmationButtonStyles: {},
                        confirmationButtonType: BUTTON_TYPE.PRIMARY,
                    }}
                    cancelButtonProps = {{
                        onCancelCb: () => dispatch(setIsQuarterSelectionPopupOpen(false)),
                        cancelButtonText: "Cancel",
                        cancelButtonStyles: {},
                        cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                    }}
                    quarterOptions={formSettings?.quarterOptions}
                />
            }
        </Loadable>
    </>
}